//Functionality shared between /home/Calendar and /admin/Calendar

var activityDetailTemplate, siteVisitDetailTemplate, shiftDetailTemplate;
var calendar;

$(function () {
  initHandlebars();
  initLegendEvents();
});

function initHandlebars() {
  activityDetailTemplate = Handlebars.compile($("#activityDetailTemplate").html());
  siteVisitDetailTemplate = Handlebars.compile($("#siteVisitDetailTemplate").html());
  shiftDetailTemplate = Handlebars.compile($('#shiftDetailTemplate').html());
}

function initLegendEvents() {
  $(document).on('click', '.activityCategoryLegendItem', function () {
    var activityCategoryId = $(this).data('activityCategoryId');

    $('#categoryFilter').val(activityCategoryId).trigger('change');

    applyAdvancedFilters('calendar');
  });

  $(document).on('click', '.siteVisitLegendItem', function () {
    $("input[type='checkbox'][name='resultTypes']").prop('checked', false);
    $("input[type='checkbox'][name='resultTypes'][value='SiteVisit']").prop('checked', true);

    applyAdvancedFilters('calendar');
  });

  $(document).on('click', '.shiftLegendItem', function () {
    $("input[type='checkbox'][name='resultTypes']").prop('checked', false);
    $("input[type='checkbox'][name='resultTypes'][value='Shifts']").prop('checked', true);

    applyAdvancedFilters('calendar');
  });
}

//Called from _SharedCalendar.js
function initResultsView() {
  var defaultDate = moment($('#startDateFilter').val(), "MM/DD/YYYY");

  calendar = new FullCalendar.Calendar(document.getElementById('calendar'), {
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,dayGridWeek,listMonth,dayGridDay'
    },
    contentHeight: "auto",
    initialView: 'dayGridMonth',
    initialDate: defaultDate.toISOString(),
    editable: false,
    eventClick: function (eventClickInfo) {
      if (eventClickInfo.event.extendedProps.eventType === 'Activity') {
        showActivityDetails(eventClickInfo.event.id);
      }
      else if (eventClickInfo.event.extendedProps.eventType === 'SiteVisit') {
        showSiteVisitDetails(eventClickInfo.event.id);
      }
      else if (eventClickInfo.event.extendedProps.eventType === 'Shift') {
        showShiftDetails(eventClickInfo.event.id);
      }
    },
    dateClick: function (info) {
      if (isAdminCalendar && hasActionPermissions) {
        var formattedDate = moment(info.date).format('MM/DD/YYYY');

        if ($('#newActivityEdit').length > 0) {
          $('#newActivityForm #StartDate').datepicker('setDate', formattedDate);
        }

        if ($('#newSiteVisitBtn').length > 0) {
          $('#newSiteVisitBtn').attr('href', '/Admin/SiteVisitProfile?date=' + formattedDate + '&returnUrl=' + returnUrl);
        }

        var left = info.jsEvent.clientX + "px";
        var top = info.jsEvent.clientY + "px";

        $('#newEventDropdown').css({ 'top': top, 'left': left, 'position': 'fixed', 'border': '1px solid black', 'padding': '5px' }).show();

        $(document).mouseup(function (e) {
          var container = $("#newEventDropdown");

          if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0) // ... nor a descendant of the container
          {
            container.hide();
            $(document).unbind('mouseup');
          }
        });
      }
    },
    events: function (info, successCallback, failureCallback) {
      var filterData = getDataFromFilterControls(info.start.valueOf(), info.end.valueOf());

      if (hasQueryParams(filterData)) {
        $('#searchFilters').collapse('show');
      }

      $.ajax({
        url: '/api/Home/CalendarEvents',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json", // send as JSON
        data: JSON.stringify(filterData),
        success: function (events) {
          var showActivities = ($('#showActivities').length) ? $('#showActivities').is(':checked') : true;
          var showSiteVisits = ($('#showSiteVisits').length) ? $('#showSiteVisits').is(':checked') : false;
          var showShifts = ($('#showShifts').length) ? $('#showShifts').is(':checked') : false;

          if (showShifts && !showActivities && !showSiteVisits) {
            calendar.changeView('listWeek');
          }

          successCallback(events);

          //Set Legend
          var activityEvents = events.filter(x => x.eventType === 'Activity' && x.activityCategoryId);

          var departmentIds = [... new Set(activityEvents.map(x => x.departmentId))];

          var activityCategoryIds = [... new Set(activityEvents.filter(x => x.activityCategoryId).map(x => x.activityCategoryId))];

          $.getJSON('/api/Home/CalendarLegend?activityCategoryIds=' + activityCategoryIds.join(','), function (data) {
            $('#legend').empty();

            var templateData = {
              isMultiDepartment: departmentIds.length > 1,
              legendItems: data
            };

            var html = legendTemplate(templateData);

            $('#legend').append(html);
          });
        },
        error: function () {
          failureCallback();
        }
      });
    },
    eventDidMount: function (info) {
      $(info.el).attr('title', info.event.title).tooltip({ placement: "right", container: 'body' });
      $(info.el).find(".fc-list-event-dot").css("border-color", info.event.backgroundColor);
    }
  });

  calendar.render();
}

function getStartDate(start) {
  return start ? moment(start).format('YYYY-MM-DD') : moment(calendar.view.activeStart).format('YYYY-MM-DD');
}

function getEndDate(end) {
  return end ? moment(end).format('YYYY-MM-DD') : moment(calendar.view.activeEnd).format('YYYY-MM-DD');
}

function showActivityDetails(activityId) {
  $.getJSON('/api/Home/CalendarActivityDetail/' + activityId, function (data) {
    var html = activityDetailTemplate({
      activityId: data.ActivityId,
      activityTitle: data.ActivityTitle,
      isAdultProgram: data.targetAgeGroup == '16 +' || data.targetAgeGroup == 'Adult Programs',
      isRegistrationRequired: data.IsRegistrationRequired,
      registrationDeadline: data.RegistrationDeadline,
      placeUrl: data.PlaceUrl,
      placeName: data.PlaceName,
      activityDate: data.ActivityDate,
      activityTime: data.ActivityTime,
      activityCategory: data.ActivityCategory,
      targetAgeGroup: data.TargetAgeGroup,
      longDescription: data.LongDescription,
      minNumberOfParticipants: data.MinNumberOfParticipants,
      maxNumberOfParticipants: data.MaxNumberOfParticipants,
      totalParticipants: data.TotalParticipants,
      isPastRegistrationDeadline: data.IsPastRegistrationDeadline,
      isFullParticipantActivity: data.IsFullParticipantActivity,
      hasVolunteerAssignments: data.VolunteerAssignments.length > 0,
      isMultiDayActivity: data.IsMultiDayActivity,
      doesRequireVolunteerAllDays: data.DoesRequireVolunteerAllDays,
      volunteerAssignments: data.VolunteerAssignments,
      hasUnfilledVolunteerAssignments: $.grep(data.VolunteerAssignments, function (e, i) {
        if (e.UserAccountId) {
          return false;
        }
        return true;
      }).length > 0,
      isAvailableForParticipantAssignment: data.IsAvailableForParticipantAssignment,
      isAvailableForParticipantWaitlist: data.IsAvailableForParticipantWaitlist && !data.IsAvailableForParticipantAssignment,
      isVolunteerOrAdminInDepartment: data.IsVolunteerOrAdminInDepartment,
      doesShowVolunteerButton: data.DoesShowVolunteerButton,
      doesShowPublicVolunteerButton: data.DoesShowPublicVolunteerButton,
      volunteerButtonText: data.VolunteerButtonText,
      volunteerButtonClass: data.VolunteerButtonClass,
      activityPhotoUrl: data.ActivityPhotoUrl,
      activityPhotoDescription: data.ActivityPhotoDescription,
      availableAssignmentCount: data.AvailableAssignmentCount,
      isBeforeVolunteerRegisterDate: data.IsBeforeVolunteerRegisterDate,
      beforeVolunteerRegisterDateMessage: data.BeforeVolunteerRegisterDateMessage,
      isBeforeParticipantRegisterDate: data.IsBeforeParticipantRegisterDate,
      beforeParticipantRegisterDateMessage: data.BeforeParticipantRegisterDateMessage,
      showPlace: data.ShowPlace,
      isPastVolunteerRegistrationDeadline: data.IsPastVolunteerRegistrationDeadline,
      hasActivityDocuments: data.HasActivityDocuments,
      activityDocuments: data.ActivityDocuments,
      activitySets: data.ActivitySets,
      hasActivitySets: data.HasActivitySets
    });

    $('#activityDetailModal').empty();
    $('#activityDetailModal').html(html);
    $('#activityDetailModal').modal('show');
  });
}

function showSiteVisitDetails(siteVisitId) {
  $.getJSON('/api/Home/SiteVisitDetail/' + siteVisitId, function (data) {
    var html = siteVisitDetailTemplate({
      siteVisitId: data.SiteVisitId,
      siteVisitTypeId: data.SiteVisitTypeId,
      isSiteVisitTypeHidden: data.IsSiteVisitTypeHidden,
      placeName: data.PlaceName,
      siteVisitTypeTitle: data.SiteVisitTypeTitle,
      title: data.Title,
      siteVisitDate: data.SiteVisitDate,
      siteVisitTime: data.SiteVisitTime,
      userAccountFirstL: data.UserAccountFirstL,
      allowVolunteerCommunication: data.AllowVolunteerCommunication,
      additionalVolunteers: data.AdditionalVolunteers
    });

    $('#siteVisitDetailModal').empty();
    $('#siteVisitDetailModal').html(html);
    $('#siteVisitDetailModal').modal('show');
  });
}

function showShiftDetails(shiftSlotId) {
  $.getJSON('/api/Home/ShiftDetail/' + shiftSlotId, function (data) {
    var html = shiftDetailTemplate({
      shiftTemplateId: data.ShiftTemplateId,
      placeName: data.PlaceName,
      placeUrl: data.PlaceUrl,
      shiftTemplateName: data.ShiftTemplateName,
      shiftSlotDescription: data.ShiftSlotDescription,
      shiftDate: data.ShiftDate,
      shiftTime: data.ShiftTime,
      hasOpenShiftSlots: data.HasOpenShiftSlots,
      canLoggedInUserSignUp: data.CanLoggedInUserSignUp
    });

    $('#shiftDetailModal').empty();
    $('#shiftDetailModal').html(html);
    $('#shiftDetailModal').modal('show');
  });
}
